import wlConfig from '@@/auto/constants/wlConfig';

const isTenant = ({ tenantDisplayName } = wlConfig) => (
  name: typeof tenantDisplayName
) => name === tenantDisplayName;

export const getComputed = (config = wlConfig) => {
  const is = isTenant(config);

  return {
    carvana: is('Carvana'),
    creditKarma: is('Credit Karma'),
    toggle: is('Toggle'),
    toyota: is('Toyota'),
    better: is('Better'),
  };
};
